import { PlainIcon } from "../../Icon";
import styled from "styled-components";

import { useDrawerContext } from "../DrawerContext";
import { ActionComponent, ActionHandler } from "../../../internalComponents";

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px 20px 18px 16px;
  order: -1;

  .actions-wrapper {
    display: flex;
  }
`;

const Title = styled.h2`
  flex-grow: 1;
  margin: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-family-alpha) !important;
  font-size: var(--size-font-medium) !important;
  font-weight: var(--font-weight-medium) !important;
  line-height: 20px;
  letter-spacing: var(--letter-spacing-wider);
`;

const CloseIconContainer = styled.span`
  margin-left: 16px;
  cursor: pointer;
  > span {
    display: block;
  }
`;

type Props = {
  children: string;
  className?: string;
  extraAction?: ActionHandler;
};

export const Header = ({
  children,
  className,
  extraAction,
}: Props): JSX.Element => {
  const { onClose } = useDrawerContext();
  return (
    <HeaderRow className={className}>
      <Title>{children}</Title>
      <div className="actions-wrapper">
        {extraAction && <ActionComponent action={extraAction} />}
        <CloseIconContainer>
          <PlainIcon iconName="x-close" onClick={onClose} />
        </CloseIconContainer>
      </div>
    </HeaderRow>
  );
};
